/**
 * @ignore
 * Created by daletan on 6/17/16.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { formatPrice, getPerItemOrSetCopy } = require('./helpers.es');
const styles = require('./pdp-price.scss');
const get = require('lodash.get');

const renderPriceType = (type, copy, showListPriceLabel) => {
    const retailPriceCopy = get(copy, 'priceStates.retailPrice') || '';
    const netPriceCopy = get(copy, 'priceStates.netPrice') || '';

    switch (type) {
        case 'retail':
            return showListPriceLabel && <span> {retailPriceCopy}</span>;
        case 'net':
            return <span> {netPriceCopy}</span>;
        default:
            return null;
    }
};

const FormattedPrice = function(props) {
    const {
        copy,
        currency,
        doNotShowFormattedPrice,
        itemHasUnlimitedQuantity,
        itemQuantity,
        itemSetSize,
        price,
        priceDisplays,
        type,
    } = props;
    const { string, abbreviation } = doNotShowFormattedPrice
        ? {}
        : formatPrice({ copy, price, currency });
    const perItemOrSet = getPerItemOrSetCopy({
        copy,
        setSize: itemSetSize,
        hasUnlimitedQuantity: itemHasUnlimitedQuantity,
        quantity: itemQuantity,
    });
    const displayPrice = doNotShowFormattedPrice ? price : string;
    let wrapperTn = 'price-wrapper';
    let priceTn = 'pdp-retail-price';
    if (priceDisplays.showOnHold) {
        priceTn = 'on-hold-price';
    } else if (priceDisplays.showPriceUponRequest) {
        priceTn = 'price-upon-request';
    } else if (type === 'net') {
        priceTn = 'pdp-net-price';
    }
    if (type) {
        wrapperTn = `${wrapperTn}-${type}`;
    }

    return (
        <span data-tn={wrapperTn}>
            <span data-tn={priceTn}>{displayPrice}</span>
            {!doNotShowFormattedPrice && (
                <span>
                    <sup className={styles.sup} data-tn="price-abbreviation">
                        {abbreviation}
                    </sup>
                    {renderPriceType(type, copy, priceDisplays.showListPriceLabel)}
                    <span data-tn="price-per-item">{perItemOrSet}</span>
                </span>
            )}
        </span>
    );
};

FormattedPrice.defaultProps = {
    copy: {},
    hasUnlimitedQuantity: false,
    priceIsString: false,
    quantity: 1,
    setSize: 1,
};

FormattedPrice.propTypes = {
    copy: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    doNotShowFormattedPrice: PropTypes.bool,
    itemHasUnlimitedQuantity: PropTypes.bool,
    itemQuantity: PropTypes.number,
    itemSetSize: PropTypes.number,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    priceDisplays: PropTypes.object.isRequired,
    type: PropTypes.string,
};

module.exports = FormattedPrice;



// WEBPACK FOOTER //
// ./assets/js/components/Price/FormattedPrice.jsx